module.exports = __webpack_public_path__ + "static/paddy-rice-94d8fe24e118ba5960842b5b5224b803.jpg";